import { ProjectStatus } from '@sib/api';

export const getProjectStatusColor = (
  status: ProjectStatus = ProjectStatus.Unassigned
) => `hsl(var(--project-status-${status}))`;
